import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'

import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll)

// import JsonExcel from "vue-json-excel";
// Vue.component("downloadExcel", JsonExcel);

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

new Vue({
  el: '#app',
  router,
  vuetify,
  render: h => h(App)
})


